'use client'
import CircumplexChart from '@crystal-eyes/components/views/profiles/CircumplexChart'
import DISCBarChart from '@crystal-eyes/components/views/profiles/DISCBarChart'
import { useState } from 'react'

interface Identity {
  id: string
}

export default function PersonalityChart({
  identities,
  mainIdentity,
  startingChart,
}: {
  identities: Identity[]
  mainIdentity: Identity
  startingChart?: 'map' | 'disc'
}) {
  const [chartSelected, setChartSelected] = useState<'map' | 'disc'>(
    startingChart || 'map',
  )

  return (
    <div className="chart-area">
      <div className="toggles">
        <div
          className={chartSelected == 'map' ? 'selected' : ''}
          onClick={() => setChartSelected('map')}
        >
          Map
        </div>

        <div
          className={chartSelected == 'disc' ? 'selected' : ''}
          onClick={() => setChartSelected('disc')}
        >
          DISC
        </div>
      </div>

      {chartSelected === 'map' && (
        <CircumplexChart
          identities={identities}
          mainIdentity={mainIdentity}
          className="my-personality-chart"
        />
      )}

      {chartSelected === 'disc' && (
        <DISCBarChart
          identities={identities}
          className="my-personality-chart"
        />
      )}
    </div>
  )
}
